import React, { useRef, Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { IceCream, Tent, HeartHandshake } from 'lucide-react';
export function MemorySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section ref={ref} className="py-20 px-4 md:px-6 bg-white/50" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-120">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-charcoal mb-4" data-id="element-121">
            What they really remember
          </h2>
          <p className="text-lg text-warm-gray" data-id="element-122">
            They won’t remember the exact toy. They’ll remember:
          </p>
        </motion.div>

        <motion.div variants={container} initial="hidden" animate={isInView ? 'show' : 'hidden'} className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-123">
          {/* Card 1 */}
          <motion.div variants={item} className="bg-white p-6 rounded-2xl shadow-md border border-stone-100 flex flex-col items-center text-center" data-id="element-124">
            <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center text-teal mb-4" data-id="element-125">
              <IceCream className="w-6 h-6" data-id="element-126" />
            </div>
            <p className="text-charcoal font-medium" data-id="element-127">
              The day you took them for ice cream and let them order first
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={item} className="bg-white p-6 rounded-2xl shadow-md border border-stone-100 flex flex-col items-center text-center" data-id="element-128">
            <div className="w-12 h-12 bg-coral/10 rounded-full flex items-center justify-center text-coral mb-4" data-id="element-129">
              <Tent className="w-6 h-6" data-id="element-130" />
            </div>
            <p className="text-charcoal font-medium" data-id="element-131">
              The blanket fort you built like it was the most important thing in
              the world
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={item} className="bg-white p-6 rounded-2xl shadow-md border border-stone-100 flex flex-col items-center text-center" data-id="element-132">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center text-amber-600 mb-4" data-id="element-133">
              <HeartHandshake className="w-6 h-6" data-id="element-134" />
            </div>
            <p className="text-charcoal font-medium" data-id="element-135">
              The way you listened when they talked about something “small” that
              was big to them
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="bg-charcoal text-cream p-8 md:p-12 rounded-3xl text-center shadow-xl mx-auto max-w-2xl relative overflow-hidden" data-id="element-136">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-teal via-coral to-teal" data-id="element-137"></div>
          <p className="font-serif text-2xl md:text-3xl italic leading-relaxed" data-id="element-138">
            “You don’t have to earn my attention. <br data-id="element-139" />
            <span className="text-teal font-bold not-italic" data-id="element-140">
              You can redeem it.
            </span>
            ”
          </p>
        </motion.div>
      </div>
    </section>;
}